/* ============================================================
   DRIPS EXOTICS — add-to-cart → native drawer (progressive enhancement)

   The add-to-cart buttons are plain <form action="/cart/add"> elements, so they
   ALWAYS work (full-page POST) even with zero JS. This script upgrades them: on
   submit it adds via /cart/add.js and calls the theme's own cart-drawer
   renderContents() — which slides the drawer in, updates the cart count, and keeps
   you on the page. On ANY problem it falls back to the native form submit, so the
   item is still added. No bespoke cart rendering — we reuse the theme's tested code.
   ============================================================ */
(function () {
  function itemsFromForm(form) {
    var fd = new FormData(form);
    var items = [];
    if (fd.has('id')) {
      items.push({ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 });
    } else {
      var i = 0;
      while (fd.has('items[' + i + '][id]')) {
        items.push({
          id: fd.get('items[' + i + '][id]'),
          quantity: parseInt(fd.get('items[' + i + '][quantity]') || '1', 10) || 1
        });
        i++;
      }
    }
    return items;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return; // only add-to-cart forms

    var drawer = document.querySelector('cart-drawer');
    // If the drawer or its render method isn't available, let the native form POST happen.
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;

    var items = itemsFromForm(form);
    if (!items.length) return; // unknown shape → native submit

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.style.opacity = '0.7'; }

    var body = {
      items: items,
      sections: drawer.getSectionsToRender().map(function (s) { return s.id; }),
      sections_url: window.location.pathname
    };

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          // e.g. sold out, min/max rule, surcharge app, etc. — let Shopify handle it natively.
          form.submit();
          return;
        }
        drawer.renderContents(res.data); // updates #CartDrawer + #cart-icon-bubble, opens the drawer
        // The empty-state flag lives on the <cart-drawer> host but the theme's
        // renderContents only clears it from .drawer__inner — so when the cart
        // started empty, the freshly-injected items stay hidden. Clear it here.
        drawer.classList.remove('is-empty');
        var items = drawer.querySelector('cart-drawer-items');
        if (items) items.classList.remove('is-empty');
        if (btn) { btn.removeAttribute('aria-disabled'); btn.style.opacity = ''; if (original != null) btn.innerHTML = original; }
      })
      .catch(function () { form.submit(); }); // network/JS error → native add
  });
})();

/* ----------------------------------------------------------------
   $36 CAD minimum order — reworked into the cart drawer (replaces the
   Madgic yellow popup, now disabled). Disables checkout under the
   minimum and shows a clean message in our own design. Runs whenever
   the drawer contents change (add / quantity / remove).
   ---------------------------------------------------------------- */
(function () {
  var MIN = 3600; // cents
  var t;
  function enforce() {
    var co = document.querySelector('#CartDrawer-Checkout') || document.querySelector('#CartDrawer [name="checkout"]');
    if (!co) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Keep the drawer's empty-state flag in sync with the real cart so items
        // always show when present and the empty state shows only when truly empty.
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.toggle('is-empty', cart.item_count === 0);
          var di = drawerEl.querySelector('cart-drawer-items');
          if (di) di.classList.toggle('is-empty', cart.item_count === 0);
        }
        var note = document.getElementById('drips-min-note');
        var under = cart.item_count > 0 && cart.total_price < MIN;
        if (under) {
          co.setAttribute('disabled', 'disabled');
          co.style.opacity = '0.5';
          co.style.pointerEvents = 'none';
          if (!note) {
            note = document.createElement('div');
            note.id = 'drips-min-note';
            note.style.cssText = 'text-align:center;font-weight:700;font-size:.85rem;color:#ED3868;padding:10px 14px 2px';
            co.parentNode.insertBefore(note, co);
          }
          note.textContent = 'Add $' + ((MIN - cart.total_price) / 100).toFixed(2) + ' more to reach the $36 minimum order';
          note.style.display = '';
        } else {
          co.removeAttribute('disabled');
          co.style.opacity = '';
          co.style.pointerEvents = '';
          if (note) note.style.display = 'none';
        }
      })
      .catch(function () {});
  }
  function debounced() { clearTimeout(t); t = setTimeout(enforce, 150); }
  function start() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(debounced).observe(drawer, { childList: true, subtree: true });
    enforce();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
